import { z } from 'zod'

import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import { columnsSchema, labelAndValue } from '@/utils/zod'

export const lessonsFiltersSchema = z.object({
  showPastData: z.boolean().optional(),
  teacherIds: z.array(labelAndValue()).optional(),
  classIds: z.array(labelAndValue()).optional(),
  courseIds: z.array(labelAndValue()).optional(),
  groupIds: z.array(labelAndValue()).optional(),
  dateAfter: z.string().optional(),
  dateBefore: z.string().optional(),
  semesterId: z.string().optional(),
  page: z.number().catch(1),
  pageSize: z.number().catch(DEFAULT_PAGE_SIZE),
  ...columnsSchema.shape
})

export type LessonsFilters = z.infer<typeof lessonsFiltersSchema>
export type LessonsFiltersKey = keyof LessonsFilters
